<template>
  <div class="receipt-view" v-if="isShow" id="printArea">
    <receipt-view-single
      :id="'printArea-'+cIdx"
      class="print-area"
      v-for="(cp,cIdx) in copies"
      :key="cIdx"
      :copyName="cp"
      :agentName="agentName"
      :stampName="stampName"
      :model="model" />
  </div>
</template>

<script>
import ReceiptViewSingle from './ReceiptViewSingle.vue'
export default {
  name: 'project-register-receipt-view',
  components: {
    ReceiptViewSingle
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => {
        return {
          industryId: null,
          cityId: null,
          method: 0, // 存储方式：0-保函|1-现金
          orderNumber: null,
          serialNo: null,
          projectName: null,
          projectSite: null,
          projectStruc: null,
          projectScale: null,
          projectCost: 0,
          projectStartDate: null,
          projectEndDate: null,
          daterange: null,
          duration: null,
          ownerName: null,
          ownerManager: null,
          ownerManagerTel: null,
          contractorName: null,
          contractorManager: null,
          contractorManagerTel: null,
          payableBase: 0,
          payableAmount: 0,
          payableRatio: 2,
          opName: null,
          opTel: null,
          supervisorName: null,
          guarantorName: null,
          guarantorAddress: null,
          guarantorContact: null,
          guarantorTel: null,
        }
      }
    }
  },
  data () {
    return {
      contentHtml: null,
      copies: [
        '第一联 监管单位留存',
        '第二联 经办机构留存',
        '第三联 劳动保障监察处留存',
        '第四联 存储单位留存'
      ],
      agents: [
        '上街区人力资源和社会保障局',
        '二七区人力资源和社会保障局',
        '中原区人力资源和社会保障局',
        '荥阳市人力资源和社会保障局',
        '中牟县人力资源和社会保障局',
        '郑东新区组织人事和社会保障局',
        '高新区管委会人力资源局',
        '新密市人力资源和社会保障局',
        '新郑市人力资源和社会保障局',
        '登封市人力资源和社会保障局',
        '惠济区人力资源和社会保障局',
        '巩义市人力资源和社会保障局',
        '经济技术开发区组织人事和社会保障局',
        '郑州航空港经济综合实验区组织人事和社会保障局',
        '金水区人力资源和社会保障局',
        '管城区人力资源和社会保障局'
      ],
      agentName: '劳动保障监察处',
      stampName: '郑州市人力资源和社会保障局农民工工资保证金业务专用章',
      thirdSheetName: '劳动保障监察处'
    }
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.procThirdSheet()
      }
    }
  },
  mounted () {
    this.procThirdSheet()
  },
  methods: {
    procThirdSheet () {
      if (this.model.orderNumber) {
        let prefix = this.model.orderNumber.substr(0, 2)
        switch (prefix) {
          case '上街':
            this.agentName = this.agents[0]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '二七':
            this.agentName = this.agents[1]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '中原':
            this.agentName = this.agents[2]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '荥阳':
            this.agentName = this.agents[3]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '中牟':
            this.agentName = this.agents[4]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '东区':
            this.agentName = this.agents[5]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '高新':
            this.agentName = this.agents[6]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '新密':
            this.agentName = this.agents[7]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '新郑':
            this.agentName = this.agents[8]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '登封':
            this.agentName = this.agents[9]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '惠济':
            this.agentName = this.agents[10]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '巩义':
            this.agentName = this.agents[11]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '经开':
            this.agentName = this.agents[12]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '港区':
            this.agentName = this.agents[13]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '金水':
            this.agentName = this.agents[14]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '管城':
            this.agentName = this.agents[15]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          default:
            this.agentName = '劳动保障监察处'
            this.stampName = '郑州市人力资源和社会保障局农民工工资保证金业务专用章'
            this.thirdSheetName = '劳动保障监察处'
            this.copies[2] = '第三联 ' + this.thirdSheetName + '留存'
            break
        }
      }
    }
  }
}
</script>

<style lang="less">
.receipt-view {

}
.print-area {
  width: 1188px;
}
</style>
